var map = {
	"./BAT.png": 663,
	"./COMP.png": 316,
	"./DAI.png": 664,
	"./ETH.png": 665,
	"./LINK.png": 666,
	"./TUSD.png": 667,
	"./UNI.png": 668,
	"./USDC.png": 669,
	"./USDT.png": 670,
	"./WBTC legacy.png": 671,
	"./WBTC.png": 672,
	"./ZRX.png": 673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 384;